var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.55 1.05l9.9 9.9M10.45 1.05l-9.9 9.9",
    stroke: "#353535"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDExIDEyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC41NTA3ODEgMS4wNTA3OEwxMC40NTAzIDEwLjk1MDMiIHN0cm9rZT0iIzM1MzUzNSIvPgo8cGF0aCBkPSJNMTAuNDQ5MiAxLjA1MDc4TDAuNTQ5NzIzIDEwLjk1MDMiIHN0cm9rZT0iIzM1MzUzNSIvPgo8L3N2Zz4K";
export { SvgX as ReactComponent };